import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getBase } from '../requests';
import Download from './Download';

interface DownloadBaseProps {
  beforeDownload?: () => void;
  afterDownload?: () => void;
}

export default function DownloadBase({
  beforeDownload,
  afterDownload,
}: DownloadBaseProps): JSX.Element {
  const { t } = useTranslation();
  const prefix = 'academicRecord.downloadBase';
  const texts = useMemo(
    () => ({
      error: t(`${prefix}.error`),
      action: t(`${prefix}.action`),
    }),
    [t],
  );

  return (
    <Download
      beforeDownload={beforeDownload}
      afterDownload={afterDownload}
      request={getBase}
      texts={texts}
      filename="RecordAcademicoBase"
    />
  );
}
